export const SHEET_DEFECTS = {
  MISSING_SHIFT_TITLE: 'MISSING_SHIFT_TITLE',
  NO_DATE_COLUMNS: 'NO_DATE_COLUMNS',
  NO_SHIFTS: 'NO_SHIFTS',
} as const;

export type SheetDefect = (typeof SHEET_DEFECTS)[keyof typeof SHEET_DEFECTS];

export type CellValue = string | number | boolean | Date | null | undefined;

export type SheetGrid = {
  sheetName: string;
  rows: CellValue[][];
};

export type TimeOfDay = {
  hour: number;
  minute: number;
};

export type DateColumn = {
  index: number;
  date: Date;
};

export type SheetLayout = {
  titleIndex: number;
  startTimeIndex: number | null;
  endTimeIndex: number | null;
  dateColumns: DateColumn[];
};

export type ScheduleEventGroupPayload = {
  scheduleEventGroupName: string;
  startTime: TimeOfDay;
  endTime: TimeOfDay;
  isAllDay: boolean;
};

export type ScheduleEventPayload = {
  title: string;
  scheduleEventGroupName: string;
  attendees: { userEmail: string }[];
  startTime: string;
  endTime: string;
  isAllDay: boolean;
};

export type RejectedCell = {
  shiftTitle: string;
  date: string;
  value: string;
};

export type ParsedSheet = {
  sheetName: string;
  defect: SheetDefect | null;
  groups: ScheduleEventGroupPayload[];
  events: ScheduleEventPayload[];
  rejectedCells: RejectedCell[];
  // Calendar dates the sheet's columns cover, independent of which rows resolved.
  dateRange: { start: string; end: string } | null;
};
